import DOMPurify from 'dompurify';

/**
 * Sanitize an HTML string before injecting it through `v-html`.
 *
 * Keeps safe formatting tags (em, strong, links, lists, headings…) while
 * stripping scripts, inline event handlers and dangerous URLs. Use this for
 * ANY `v-html` bound to content that is not 100% static/trusted (markdown
 * output, notification bodies, third-party search snippets, etc.).
 *
 * @param {string|null|undefined} html
 * @returns {string}
 */
export function sanitizeHtml(html) {
    if (html === null || html === undefined) {
        return '';
    }

    return DOMPurify.sanitize(String(html), { USE_PROFILES: { html: true } });
}

/**
 * Calcule le n° de TVA intracommunautaire français (FR + clé de 2 chiffres +
 * SIREN) à partir d'un SIREN. Retourne null si le SIREN nettoyé ne fait pas
 * 9 chiffres. Même formule de clé que la validation serveur
 * (App\Traits\ValidatesSirenNumeroTva).
 *
 * @param {string|null|undefined} siren
 * @returns {string|null}
 */
export function computeNumeroTvaFromSiren(siren) {
    const cleaned = (siren ?? '').replace(/\s/g, '');
    if (!/^\d{9}$/.test(cleaned)) {
        return null;
    }

    const key = String((12 + 3 * (Number(cleaned) % 97)) % 97).padStart(2, '0');

    return `FR${key}${cleaned}`;
}

export function formatSiren(siren) {
    if (typeof siren === 'string') {
        // Insérer un espace tous les trois chiffres
        return siren?.replace(/(\d{3})(?=\d)/g, "$1 ");
    }
}

export function formatSiret(siret) {
    if (typeof siret === 'string') {
        return siret.replace(/(\d{3})(\d{3})(\d{3})(\d{5})/g, "$1 $2 $3 $4");
    }
}

export function formatCurrency(value, digits = 2) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: digits,
    }).format(value);
}

export function isUrl(value) {
    const pattern = /^(https?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-\._~:/?#\[\]@!$&'()*+,;=]+$/;
    return pattern.test(value);
}

export function formatGenreIso(genre) {
    // Return genre according to ISO/CEI 5218
    switch (genre) {
        case 0:
            return 'Non renseigné';
        case 1:
            return 'Homme';
        case 2:
            return 'Femme';
        case 9:
            return 'Non applicable';
        default:
            return 'Non renseigné';
    }
}

export function formatGenre(genre) {
    // Return genre according to ISO/CEI 5218
    switch (genre) {
        case "0":
            return '';
        case "1":
            return 'M.';
        case "2":
            return 'Mme';
        case "9":
            return '';
        default:
            return '';
    }
}
export function openSanctionGenderLabel(gender) {
    // Miroir de OpenSanctionChecker::getGenderLabel (valeurs OpenSanctions 'male'/'female')
    const labels = {male: 'Homme', female: 'Femme'};
    return labels[gender] || gender || '';
}
